import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SubMenuItem } from 'src/app/core/models/menu.model';
import packageJson from '../../../../../../package.json';
import { MenuService } from '../../services/menu.service';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AngularSvgIconModule,
    RouterLink,
    NgFor,
    NgClass,
    NgTemplateOutlet,
    RouterLinkActive,
    MatIconModule,
    TranslateModule,
    SidebarMenuComponent,
  ],
})
export class SidebarComponent implements OnInit {
  public appJson: any = packageJson;
  @Output() openSidebarDrawer = new EventEmitter<void>();

  constructor(public menuService: MenuService) {}

  private readonly router = inject(Router);

  ngOnInit(): void {}

  toggleSidebar() {
    this.menuService.toggleSidebar();
  }

  onNavigateUrl(item: SubMenuItem) {
    if (item.children && item.children.length <= 0) {
      this.router.navigate([`${item.route}`]);
    }
  }

  toggleMenu(subMenu: SubMenuItem) {
    if (subMenu.children && subMenu.children.length > 0) {
      this.openSidebarDrawer.emit();
    }
    // this.menuService.toggleMenu(subMenu);
  }
}
